<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getRegions, deleteRegion as deleteRow } from "@/api/regions";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  id: "id",
  edit: true,
  delete_row: {
    buttonName: "Удалить",
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
    sortable: false,
  },
  {
    prop: "name",
    label: "Наименование региона",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        async fetchData(params) {
          const data = await getRegions(params);
          return data.regions;
        },
        deleteRow,
      },
    };
  },
};
</script>
